module.exports = __webpack_public_path__ + "img/upgrade.193bbd10.png";